import React from 'react';
import { connect } from 'react-redux';
import { resetPatternColors } from '../../actions/recoloring';
import * as types from '../../actions/actionTypes';
import ColoredFlatButton from '../buttons/ColoredFlatButton';
import { resetColorSlider } from '../../actions/uiActions';

const ResetColors = ({ resetColors, resetSliders, reload, children, patternid, sewpatId, left }) => {
    const handleClick = event => {
        event.preventDefault();
        resetColors(patternid);
        resetSliders(true);
        reload(patternid, sewpatId);
    };

    return (
        <ColoredFlatButton
            mt={7} mb={7} bgColor='rgba(0, 0, 0, 0.08)'
            onClick={handleClick} text={children}
        />
    );
};

const mapDispatch = dispatch => ({
    resetColors: patternid => dispatch(resetPatternColors(patternid)),
    resetSliders: bool => dispatch(resetColorSlider(bool)),
    reload: (patternid, sewpatId) => dispatch({
        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
        payload: { patternid, sewpatId },
    }),
});

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const { patternid, sewpatId } = initialState.location.payload;
    const mapStateToProps = state => ({
        patternid,
        sewpatId,
    });
    return mapStateToProps;
};

export default connect(makeMapStateToProps, mapDispatch)(ResetColors);



// WEBPACK FOOTER //
// ./src/components/recoloring/ResetColors.js